module.exports = __webpack_public_path__ + "img/moonMilk-400xp.7e7d21ad.png";